<script>
	import { Accordion, AccordionItem } from "@sveltestrap/sveltestrap";
	import { onMount } from "svelte";
	import client from "src/services/client";
	import Exterior from "../VehicleIssues/ApprovedIssueTabs/Exterior.svelte";
	import Drive from "../VehicleIssues/ApprovedIssueTabs/Drive.svelte";
	import Tabs from "../../../../../components/Tabs/Tabs.svelte";
	import { totalPages, currentCarSection, initPage } from "src/store/store";
	import queryString from "query-string";

	export let issues;
	export let approvedIssues;

	let activeTab;
	let unique = {};

	const query = queryString.parse(window.location.search);
	let searchParams = new URLSearchParams(window.location.search);

	const fetchApprovedIssues = async (
		reportSection = "1",
		carSection = "1"
	) => {
		try {
			initPage.set(1);
			let queryData = `?PlateNumber=${issues.vehicleNumber}&ReportSection=${reportSection}&Page=${query.page}&Size=20`;
			if (reportSection === "3") {
				let carSectionQuery = `&CarSection=${carSection}`;
				queryData += carSectionQuery;
			}

			const res = await client(`/v0/Cmm/approved-issue${queryData}`, {
				method: "GET",
				version: "Tasking",
			});

			approvedIssues = res.data.data;
			totalPages.set(res.data.totalPage);
			activeTab = reportSection === "1" ? 1 : 2;
			return;
		} catch (err) {
			console.log(err);
			console.log(err.response);
		}
	};

	onMount(async () => {
		fetchApprovedIssues();
	});

	let items = [
		{
			label: "Drive",
			value: 1,
			component: Drive,
		},
		{
			label: "Exterior",
			value: 2,
			component: Exterior,
		},
	];

	const options = {
		rewind: true,
		perPage: 2,
		gap: "1px",
		autoWidth: true,
		height: "15rem",
	};

	const selectCarSection = async (carSectionValue, carSectionLabel) => {
		try {
			let queryCarSection = carSectionValue
				? `&CarSection=${String(carSectionValue)}`
				: "";
			let queryReportSection = `&ReportSection=3`;
			let queryData =
				`?PlateNumber=${issues.vehicleNumber}&Page=${query.page}&Size=20` +
				queryCarSection +
				queryReportSection;

			const res = await client(`/v0/Cmm/approved-issue${queryData}`, {
				method: "GET",
				version: "Tasking",
			});

			approvedIssues = res.data.data;
			totalPages.set(res.data.totalPage);
			currentCarSection.set(carSectionLabel);
			initPage.set(query.page);
			unique = {};
		} catch (err) {
			console.log(err);
			console.log(err.response);
		}
	};
</script>

<Accordion>
	<AccordionItem active="true">
		<span slot="header">Approved Issues</span>

		{#if approvedIssues == undefined}
			<div class="text-center">... Fetching issue data</div>
		{:else}
			<Tabs
				{items}
				{options}
				data={approvedIssues}
				{activeTab}
				{selectCarSection}
				{fetchApprovedIssues}
				{unique}
			/>
		{/if}
	</AccordionItem>
</Accordion>
